import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  getUserPreferencesApiThunk,
  updateUserPreferencesApiThunk,
  clearUserPreferencesMessages,
  resetUpdateApiStatus,
} from './userPreferencesSlice';
import { RootState } from '..';
import {
  GetUserPreferencesRequest,
  UpdateUserPreferencesRequest,
} from 'src/types/orbit/UserPreferences';

export const useUserPreferences = () => {
  const dispatch = useAppDispatch();
  const userPreferences = useAppSelector(
    (state: RootState) => state.userPreferences.userPreferences,
  );
  const getUserPreferencesApiStatus = useAppSelector(
    (state: RootState) => state.userPreferences.getUserPreferencesApiStatus,
  );
  const updateUserPreferencesApiStatus = useAppSelector(
    (state: RootState) => state.userPreferences.updateUserPreferencesApiStatus,
  );

  const loadUserPreferences = useCallback(
    (data: GetUserPreferencesRequest) => {
      dispatch(getUserPreferencesApiThunk(data));
    },
    [dispatch],
  );

  const updateUserPreferences = useCallback(
    (data: UpdateUserPreferencesRequest) => {
      dispatch(updateUserPreferencesApiThunk(data));
    },
    [dispatch],
  );

  const clearAllUserPreferencesApiMessages = useCallback(() => {
    dispatch(clearUserPreferencesMessages());
  }, [dispatch]);

  const resetUpdateStatus = useCallback(() => {
    dispatch(resetUpdateApiStatus());
  }, [dispatch]);

  return {
    userPreferences,
    getUserPreferencesApiStatus,
    updateUserPreferencesApiStatus,
    loadUserPreferences,
    updateUserPreferences,
    clearAllUserPreferencesApiMessages,
    resetUpdateStatus,
  };
};
